import { swiper_update_height} from "../sliders/sliders.js";

(function ($) {
    let page = 2;
    let buttonMoreSelector = ".recent-bets .block__item-wrap .btn-load";
    let container = ".recent-bets .block__item-wrap";

    $('body').on('click', buttonMoreSelector, function () {
        var url = "https://" + window.location.host + "/engine/function/my-bets-loader.php?page=" + page;
        $.ajax({
            url: url,
            success: function (response) {
                // console.log(response);
                if (!response || response.trim() == "NONE") {
                    $(buttonMoreSelector).fadeOut();
                    //$(loadingSelector).show().text("No more bets!");
                    return;
                }
                page += 1;
                $(response).insertBefore($(buttonMoreSelector));
                //remove from buttonMoreSelector classes load disable
                $(buttonMoreSelector).removeClass('load disabled');
            },
            error: function (response) {
                //$(loadingSelector).text("Sorry, there was some error with the request. Please refresh the page.");
            },
            complete: function () {
                swiper_update_height();
            }
        });
    })

    // //show hide bets in express
    // $('body').on('click', '.my-bets__item.express_bet .my-bets__item_middle, .my-bets__item.event_bet .my-bets__item_middle', function () {
    //     var $parentDiv = $(this).parents('.my-bets__item');
    //     $parentDiv.find('.my-bets__express_matches').toggle();
    //     $(this).find('.express_details_js_arrow').toggleClass('express_details_js_arrow-on');
    //     $(window).resize();
    // });



    // //show all items in bet
    // $('body').on('click', '.game_items__more_items_block', function () {
    //     var $parentDiv = $(this).parent('.items__container-items');
    //     $(this).remove();
    //     $parentDiv.find('.game_item.nice_item').show();
    //     $(window).resize();
    // });


})(jQuery);